(function () {
    'use strict';

    angular
        .module('app.gameTracker')
        .constant('gameTrackerResolver', {
            individualId: getIndividualId,
            courseId: getCourseId,
            category: getCategory,
            range: getRange,
            courseList: getCourseList
        });

    var gettext = angular.identity;

    // IndividualId
    getIndividualId.$inject = ['$transition$', 'user'];
    function getIndividualId($transition$, user) {
        return $transition$.params().individualId || user.id;
    }

    // CourseId
    getCourseId.$inject = ['$transition$'];
    function getCourseId($transition$) {
        return $transition$.params().courseId || null;
    }

    // Category
    getCategory.$inject = ['$transition$', 'gameTrackCategory'];
    function getCategory($transition$, gameTrackCategory) {
        return $transition$.params().category || gameTrackCategory.Summary;
    }

    // Range
    getRange.$inject = ['$transition$', 'gameTrackRange'];
    function getRange($transition$, gameTrackRange) {
        return $transition$.params().range || gameTrackRange.Last20;
    }
    
    // Courses
    getCourseList.$inject = ['GameTracker', '$transition$', 'user', 'gettextCatalog'];
    function getCourseList(GameTracker, $transition$, user, gettextCatalog) {
        var courseList = $transition$.params().courseList,
            individualId = $transition$.params().individualId || user.id;

        return courseList ? courseList : individualId ? GameTracker.getCourses({ individualId: individualId }).$promise.then(addAllCourses) : [];

        function addAllCourses(courseList) {
            courseList.unshift({ id: null, name: gettextCatalog.getString(gettext('All Courses')) });
            return courseList;
        }
    }
})();